/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from "react";
import Lottie from 'lottie-react';
import Referlottie from "../../Lottie/refernearn.json";
import { MyContext } from "../../Context/MyProvider";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { showToast } from "../../showTost";
import { useTranslation } from "react-i18next";
import Icon from "../../image/lovef.png";
const Refer = () => {

    const { t } = useTranslation();
    const { ApiBasUrl } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [referdata, setReferData] = useState({});

    const Currency = secureLocalStorage.getItem("currency");

    useEffect(() => {
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            axios.post(`${ApiBasUrl}/referdata.php`, { uid: Userid })
                .then((res) => {
                    const { code, refercredit, signupcredit } = res.data;
                    setReferData({ code, refercredit, signupcredit });
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("referdata.php", error);
                });
        }
    }, []);

    const handleCopyClick = (Text) => {
        navigator.clipboard.writeText(Text).then(() => {
            showToast({ title: t("Text copied to clipboard !!"), id: "success" });
        });
    };

    return (
        <div>
            {loading
                ? <div className="w-full h-[100vh] bg-white fixed top-0 flex items-center justify-center">
                    <div className="loader2"></div>
                </div>
                : <div className="width_container">
                    <div className="w-full h-[100vh] flex items-center justify-center -mt-[90px]">
                        <div className="profile_box">
                            <div className="text-center">
                                <Lottie
                                    className="w-[250px] mx-auto mb-[20px] max-_430_:w-[200px]"
                                    animationData={Referlottie}
                                    loop={true}
                                />
                                <h1 className="text-center font-bold text-[20px]">{t("Eran")} {Currency + referdata?.signupcredit} {t("for Each Friend you refer")}</h1>
                            </div>

                            <div className="">
                                <div className="flex items-center gap-[10px] mt-[15px]">
                                    <img src={Icon} className="max-w-[30px] min-w-[30px]" alt="Icon" />
                                    <h1 className="font-[500] text-[17px]">{t("Share the referral link with your friends")}</h1>
                                </div>
                                <div className="flex items-center gap-[10px] mt-[15px]">
                                    <img src={Icon} className="max-w-[30px] min-w-[30px]" alt="Icon" />
                                    <h1 className="font-[500] text-[17px]">{t("Friend get")} <span className="font-[500]">{Currency + referdata?.signupcredit}</span> {t("on first complete transaction")} </h1>
                                </div>
                                <div className="flex items-center gap-[10px] mt-[15px]">
                                    <img src={Icon} className="max-w-[30px] min-w-[30px]" alt="Icon" />
                                    <h1 className="font-[500] text-[17px]">{t("You get")} <span className="font-[500]">{Currency + referdata?.refercredit}</span> {t("on your wallet")}</h1>
                                </div>
                            </div>

                            <div className="w-full mt-[30px] flex justify-center">
                                <button onClick={() => handleCopyClick(referdata?.code)} className="border-[2px] border-[#682afb] px-[30px] py-[8px] rounded-[10px]">
                                    <div className="flex items-center gap-[10px] text-[#682afb] font-[500]">
                                        <span>{referdata?.code}</span>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18.375 6.25H9.625C7.448 6.25 6.25 7.448 6.25 9.625V18.375C6.25 20.552 7.448 21.75 9.625 21.75H18.375C20.552 21.75 21.75 20.552 21.75 18.375V9.625C21.75 7.448 20.552 6.25 18.375 6.25ZM20.25 18.375C20.25 19.707 19.707 20.25 18.375 20.25H9.625C8.293 20.25 7.75 19.707 7.75 18.375V9.625C7.75 8.293 8.293 7.75 9.625 7.75H18.375C19.707 7.75 20.25 8.293 20.25 9.625V18.375ZM3.75 5.62V14.38C3.75 15.578 4.23309 15.873 4.39209 15.971C4.74609 16.187 4.85589 16.649 4.63989 17.002C4.49789 17.233 4.25202 17.36 3.99902 17.36C3.86602 17.36 3.72991 17.324 3.60791 17.25C2.70691 16.698 2.25 15.733 2.25 14.38V5.62C2.25 3.478 3.47912 2.25 5.62012 2.25H14.3799C16.0649 2.25 16.87 2.98897 17.25 3.60797C17.466 3.96097 17.355 4.42298 17.002 4.63898C16.648 4.85598 16.1879 4.74399 15.9709 4.39099C15.8739 4.23199 15.5779 3.74902 14.3799 3.74902H5.62012C4.29212 3.75002 3.75 4.292 3.75 5.62Z" fill="currentColor" />
                                        </svg>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>}
        </div>
    )
}

export default Refer;
/* jshint ignore:end */